import React from "react";
import { Outlet } from "react-router-dom";

const QueryRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default QueryRoot;
